/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_UncategorizedInputs */

const en_directory_launch_uncategorized = /** @type {(inputs: Directory_Launch_UncategorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uncategorized`)
};

const zh_directory_launch_uncategorized = /** @type {(inputs: Directory_Launch_UncategorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未分类`)
};

/**
* | output |
* | --- |
* | "Uncategorized" |
*
* @param {Directory_Launch_UncategorizedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_uncategorized = /** @type {((inputs?: Directory_Launch_UncategorizedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_UncategorizedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_uncategorized(inputs)
	return zh_directory_launch_uncategorized(inputs)
});
export { directory_launch_uncategorized as "directory.launch.uncategorized" }